/**
 * Компонент поля ввода с поддержкой label, error сообщений и testId
 */
import { forwardRef, InputHTMLAttributes } from 'react';
import { cn } from '@/utils/cn';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  testId?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, testId, className, ...props }, ref) => {
    return (
      <div>
        {label && (
          <label className="block text-sm font-medium text-shell-text mb-1.5">
            {label}
          </label>
        )}
        <input
          ref={ref}
          data-testid={testId}
          className={cn(
            'shell-input',
            error && 'border-shell-danger focus:!border-shell-danger',
            className
          )}
          {...props}
        />
        {error && (
          <span className="text-shell-danger text-sm mt-1 block">{error}</span>
        )}
      </div>
    );
  }
);

Input.displayName = 'Input';

